<div class="document-library" *ngIf="classFileList != ''">

  <!-- ================= HEADER ================= -->
  <section class="library-header" *ngIf="viewControl.showHideEditFileUpload && viewControl.hideExistingFileView">

    <!-- ================= STATISTICS ================= -->

    <div class="library-stats">

      <div class="stat-card select-all-card">
        <label class="select-all">
          <input type="checkbox" id="select_all" [checked]="areAllSelected" (change)="onSelectAllChange($event)" />

          <span class="custom-check">
            <i class="pi pi-check"></i>
          </span>

          <span class="select-all-text">Select All</span>
        </label>
      </div>

      <div class="stat-card">
        <div class="stat-icon documents">
          <i class="pi pi-file"></i>
        </div>

        <div>
          <span class="stat-value">
            {{ totalDocumentCount }}
          </span>
          <span class="stat-label">
            Documents
          </span>
        </div>
      </div>


      <div class="stat-card">
        <div class="stat-icon users">
          <i class="pi pi-users"></i>
        </div>

        <div>
          <span class="stat-value">
            {{ totalUserCount }}
          </span>

          <span class="stat-label">
            Users
          </span>
        </div>
      </div>


      <!-- <div class="stat-card stat-info-card">
        <div class="stat-icon storage">
          <i class="pi pi-cloud"></i>
        </div>

        <div>
          <span class="stat-value">
            {{ classFileList.length }}
          </span>

          <span class="stat-label">
            Available Files
          </span>
        </div>
      </div> -->

    </div>

  </section>


  <!-- ================= DOCUMENT GRID ================= -->

  <section class="document-grid" #dropListContainer cdkDropListGroup *ngIf="
      viewControl.showHideEditFileUpload &&
      viewControl.hideExistingFileView
    ">

    <div class="document-grid-item" [class.menu-open]="show && dropdownIndex === $index" *ngFor="let item of classFileList; let $index = index" cdkDropList
      [cdkDropListData]="$index">
      <article class="document-card" cdkDrag [cdkDragData]="$index" (cdkDragEntered)="dragEntered($event)"
        (cdkDragMoved)="dragMoved($event)" (cdkDragDropped)="dragDropped($event)">

        <!-- DRAG -->
        <button type="button" class="drag-button" cdkDragHandle *ngIf="DraggableEnable" title="Move document">
          <i class="pi pi-arrows-alt"></i>
        </button>


        <!-- CHECKBOX -->
        <div class="document-check" *ngIf="isSelectableFile(item)" (click)="$event.stopPropagation()">

          <input type="checkbox" [id]="item.message_id" name="documents" [checked]="isDoc_id(item)"
            (change)="selectDocument($event, item)" (click)="$event.stopPropagation()" />

          <label [for]="item.message_id">
            <i class="pi pi-check"></i>
          </label>

        </div>


        <!-- PREVIEW -->
        <div class="document-preview" (click)="viewSecureFile(item.message_id, item, $index)">

          <!-- IMAGE / VIDEO -->
          <ng-container *ngIf="isVideoOrImage(item); else documentIcon">

            <img class="document-thumbnail" [src]="item.thumb_url" [alt]="item.message || 'Document'" />

            <div class="preview-overlay">

              <button type="button" class="preview-button" (click)="
                  $event.stopPropagation();
                  viewSecureFile(item.message_id, item, $index)
                ">

                <i class="pi" [ngClass]="{
                    'pi-eye': item.file_type === 'image',
                    'pi-play': item.file_type !== 'image'
                  }"></i>

              </button>

            </div>

          </ng-container>


          <!-- OTHER FILE -->
          <ng-template #documentIcon>

            <div class="file-icon-wrapper">

              <img class="file-type-icon" [src]="
                  '../../../../assets/images/file_types/' +
                  item.file_ext +
                  '.png'
                " [alt]="item.file_ext" />

            </div>

            <div class="preview-overlay">

              <button type="button" class="preview-button" (click)="
                  $event.stopPropagation();
                  viewSecureFile(item.message_id, item, $index)
                ">

                <i class="pi" [ngClass]="{
                    'pi-eye': item.file_type !== 'audio',
                    'pi-play': item.file_type === 'audio'
                  }"></i>

              </button>

            </div>

          </ng-template>


          <!-- VIDEO DURATION -->
          <span class="video-duration" *ngIf="item.duration && item.duration !== 'null' && item.file_ext == 'mp4'">
            <i class="pi pi-clock"></i>
            {{ item.duration }}
          </span>


          <!-- FILE EXTENSION -->
          <span class="file-extension" *ngIf="item.file_ext">
            {{ item.file_ext }}
          </span>

        </div>


        <!-- CONTENT -->
        <div class="document-body">

          <div class="document-main">

            <h3 class="document-title" [title]="item.message || 'No Title'">
              {{
              item.message
              ? (
              item.message.length > 35
              ? (item.message | slice:0:35) + '...'
              : item.message
              )
              : 'No Title'
              }}
            </h3>


            <div class="document-meta">

              <span>
                <i class="pi pi-user"></i>

                {{
                item.shared_by?.length > 22
                ? (item.shared_by | slice:0:22) + '...'
                : item.shared_by
                }}
              </span>

              <span>
                <i class="pi pi-eye"></i>
                {{ item.read_user_ids?.length || 0 }}
              </span>

            </div>

          </div>


          <!-- ACTIONS -->
          <div class="document-actions">

              <!-- VIEW (NEW) -->
            <button type="button" class="icon-action" title="View"
              (click)="$event.stopPropagation(); viewSecureFile(item.message_id, item, $index)">
              <i class="pi pi-eye"></i>
            </button>

            <!-- SUMMARY -->
            <button type="button" class="icon-action" title="Summarize" *ngIf="item.summary"
              (click)="$event.stopPropagation(); showSummarize(item.message_id)">
              <i class="pi pi-file"></i>
            </button>


            <!-- PUBLISH -->
            <button type="button" class="icon-action publish" title="Publish"
              *ngIf="isUserRole === 1 || isUserRole === 2" (click)="
                $event.stopPropagation();
                Published(item.message_id, $index)
              ">
              <i class="pi" [ngClass]="{
                  'pi-send': !item.is_publish,
                  'pi-check-circle': item.is_publish
                }"></i>
            </button>


            <!-- DOWNLOAD -->
            <button type="button" class="icon-action" title="Download" *ngIf="item.is_download" (click)="
                $event.stopPropagation();
                secureFileDownLoad(item)
              ">
              <i class="pi pi-download"></i>
            </button>


            <!-- MORE -->
            <div class="document-menu" *ngIf="
                isUserRole === 1 ||
                isUserRole === 2 ||
                item.is_polls_found ||
                item.is_survey_found ||
                item.is_question_found
              ">

              <button type="button" class="icon-action" title="More options" (click)="clickit($event, $index)">
                <i class="pi pi-ellipsis-v"></i>
              </button>


                <div class="modern-dropdown"
                    [class.show]="show && dropdownIndex === $index"
                    [class.opens-up]="dropdownUpIndex === $index"
                    [class.opens-left]="dropdownLeftIndex === $index"
                    (click)="$event.stopPropagation()">

                <button *ngIf="false" (click)="getQuizeDetails(item.message_id)">
                  <i class="pi pi-pencil"></i>
                  Edit
                </button>

                 <!-- NEW: edit extracted document content -->
                <button *ngIf="['pdf','doc','docx','xls','xlsx'].includes(item.file_ext)" (click)="onEditExtractedContent(item, $index)">
                  <i class="pi pi-table"></i>
                  Edit Contents
                </button>

                <button *ngIf="item.is_question_found" (click)="loadAssessmentQuiz(item.message_id, 'question')">
                  <i class="pi pi-chart-bar"></i>
                  Assessment Result
                </button>

                <button *ngIf="item.is_survey_found" (click)="loadAssessmentQuiz(item.message_id, 'survey')">
                  <i class="pi pi-list"></i>
                  Survey Result
                </button>

                <button *ngIf="item.is_polls_found" (click)="loadAssessmentQuiz(item.message_id, 'polls')">
                  <i class="pi pi-chart-pie"></i>
                  Poll Result
                </button>

                <button *ngIf="isUserRole === 1 || isUserRole === 2" class="danger" (click)="deleteSecureFile(item)">
                  <i class="pi pi-trash"></i>
                  Delete
                </button>

              </div>

            </div>

          </div>

        </div>


        <!-- FOOTER -->
        <div class="document-footer">

          <span>
            <i class="pi pi-calendar"></i>
            {{ item.created_at | date:'MMM d, y' }}
          </span>

          <span class="published-badge" *ngIf="item.is_publish">
            <i class="pi pi-check"></i>
            Published
          </span>

        </div>

      </article>

    </div>

  </section>


  <!-- ================================================= -->
  <!-- DOCUMENT VIEWER -->
  <!-- ================================================= -->

  <section class="document-viewer-layout" *ngIf="!viewControl.hideExistingFileView">

    <!-- MAIN VIEWER -->
    <div class="viewer-main">

      <div class="viewer-card">

        <!-- TOP BAR -->
        <div class="viewer-header">

          <button type="button" class="back-button" (click)="disabledVideoPlay()">
            <i class="pi pi-arrow-left"></i>
            <span>Back to Documents</span>
          </button>


          <div class="viewer-actions">

            <button type="button" class="viewer-icon" *ngIf="mediaContent?.is_download"
              (click)="secureFileDownLoad(mediaContent)" title="Download">
              <i class="pi pi-download"></i>
            </button>

          </div>

        </div>


        <!-- MEDIA -->
        <div class="viewer-content">

          <div class="watermark" *ngIf="mediaContent?.watermark">
            {{ mediaContent.watermark }}
          </div>


          <!-- VIDEO / AUDIO -->
          <div class="media-container" *ngIf="
              mediaContent?.file_type === 'video' ||
              mediaContent?.file_type === 'audio'
            ">

            <vg-player *ngIf="mediaContent?.file_type === 'video'" (onPlayerReady)="videoPlayerInit($event)">

              <vg-overlay-play></vg-overlay-play>
              <vg-buffering></vg-buffering>

              <video #media [vgMedia]="media" id="singleVideo" crossorigin
                (timeupdate)="getVideoPlayingOnTime($event.target.currentTime)">
                <source [src]="inputSrc" type="video/mp4" />
              </video>

              <vg-controls [vgAutohide]="true">

                <vg-play-pause></vg-play-pause>

                <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                <vg-scrub-bar></vg-scrub-bar>

                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                <vg-mute></vg-mute>
                <vg-volume></vg-volume>
                <vg-fullscreen></vg-fullscreen>

              </vg-controls>

            </vg-player>


            <!-- AUDIO -->
            <vg-player *ngIf="mediaContent?.file_type === 'audio'" class="audio-player"
              (onPlayerReady)="videoPlayerInit($event)">

              <div class="audio-artwork">
                <i class="pi pi-volume-up"></i>
              </div>

              <vg-controls>

                <vg-play-pause></vg-play-pause>

                <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                <vg-scrub-bar></vg-scrub-bar>

                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                <vg-mute></vg-mute>
                <vg-volume></vg-volume>

              </vg-controls>

              <audio #audio [vgMedia]="audio" id="myAudio" preload="none">
                <source [src]="inputSrc" type="audio/mpeg" />
              </audio>

            </vg-player>

          </div>


          <!-- IMAGE -->
          <img *ngIf="mediaContent?.file_type === 'image'" class="viewer-image" [src]="mediaContent.view_Url"
            [ngxWatermark]="options" />


          <!-- DOCUMENT -->
          <div class="document-frame" *ngIf="
              mediaContent &&
              mediaContent.file_type !== 'video' &&
              mediaContent.file_type !== 'audio' &&
              mediaContent.file_type !== 'image'
            ">

            <app-page-loader *ngIf="showFileLoadSpinner"></app-page-loader>

            <ngx-doc-viewer [url]="selectedReadFile" viewer="google" [googleCheckContentLoaded]="true"
              [googleCheckInterval]="3000" [googleMaxChecks]="5" (loaded)="contentLoaded()">
            </ngx-doc-viewer>

          </div>

        </div>


        <!-- DETAILS -->
        <div class="viewer-details">

          <div>

            <h2>
              {{ mediaContent?.message || 'No Title' }}
            </h2>

            <p>
              <i class="pi pi-user"></i>
              {{ mediaContent?.shared_by }}
            </p>

          </div>


          <div class="viewer-date">

            <i class="pi pi-calendar"></i>

            {{ mediaContent?.created_at | date:'MMM d, y' }}

          </div>

        </div>


        <!-- NAVIGATION -->
        <div class="viewer-navigation">

          <button type="button" [disabled]="prevDisabled || classFileList.length === 1"
            (click)="getPreVideo(currentIndex)">
            <i class="pi pi-arrow-left"></i>
            Previous
          </button>


          <button type="button" [disabled]="nextDisabled || classFileList.length === 1"
            (click)="getNextVideo(currentIndex)">
            Next
            <i class="pi pi-arrow-right"></i>
          </button>

        </div>


        <!-- DESCRIPTION -->
        <div class="description" *ngIf="mediaContent?.description">

          <h3>Description</h3>

          <div [innerHTML]="mediaContent.description"></div>

        </div>

      </div>

    </div>


    <!-- ================================================= -->
    <!-- RIGHT SIDEBAR -->
    <!-- ================================================= -->

    <aside class="viewer-sidebar">

      <div class="sidebar-tabs">

        <button [class.active]="seletedTab === 'lessons'" (click)="openTab($event, 'lessons')">
          <i class="pi pi-file"></i>
          Documents
        </button>

        <button *ngIf="isUserRole != 1 && isUserRole != 2" [class.active]="seletedTab === 'notes'"
          (click)="openTab($event, 'notes')">
          <i class="pi pi-pencil"></i>
          Notes
        </button>

      </div>


      <!-- DOCUMENT LIST -->
      <div class="sidebar-content" *ngIf="seletedTab === 'lessons'">

        <div class="playlist-item" *ngFor="
            let vdo of classFileList;
            let $index = index
          " [class.active]="
            vdo === currentVideo ||
            vdo.message_id === currentVideoId
          " (click)="startPlayListVdo($index, vdo)">

          <div class="playlist-icon">

            <i class="pi" [ngClass]="{
                'pi-video': vdo.file_type === 'video',
                'pi-volume-up': vdo.file_type === 'audio',
                'pi-file': vdo.file_type !== 'video' &&
                           vdo.file_type !== 'audio'
              }"></i>

          </div>


          <div class="playlist-info">

            <h4>
              {{ vdo.message || 'No Title' }}
            </h4>

            <span>
              {{ vdo.created_at | date:'MMM d, y' }}
            </span>

          </div>


          <i class="pi pi-check-circle selected-icon" *ngIf="vdo.message_id === currentVideoId"></i>

        </div>

      </div>


      <!-- NOTES -->
      <div class="notes-panel" *ngIf="
          isUserRole != 1 &&
          isUserRole != 2 &&
          seletedTab === 'notes'
        ">

        <form [formGroup]="userNotesForm">

          <div class="note-item" *ngFor="
              let item of userNotes;
              let i = index
            ">

            <h4>
              {{ i + 1 }}.
              <span [innerHTML]="item.question"></span>
            </h4>

            <textarea formControlName="notes" placeholder="Write your answer or notes..."
              [value]="item.notes ? item.notes : ''"
              (change)="changeEventUserNotes(item, userNotesForm.value)"></textarea>

          </div>


          <div class="empty-note" *ngIf="!is_notes">

            <p-editor formControlName="notes" [config]="editorIsNotesConfig" [style]="{ height: '220px' }"></p-editor>

          </div>


          <div class="notes-actions">

            <button type="button" class="secondary-btn" (click)="userNotesDownload(userNotes)">
              <i class="pi pi-download"></i>
              Download
            </button>


            <button type="button" class="primary-btn" [disabled]="
                (userNotesForm.valid && !userNotesForm.dirty) ||
                userNotesForm.invalid
              " *ngIf="!showBtnSpinner && userNotes.length === 0"
              (click)="submitUserNotes(userNotesForm.value, msgIds)">
              Save Notes
            </button>


            <button type="button" class="primary-btn" [disabled]="
                (userNotesForm.valid && !userNotesForm.dirty) ||
                userNotesForm.invalid
              " *ngIf="!showBtnSpinner && userNotes.length > 0"
              (click)="updatedUserNotes(userNotesForm.value, msgIds)">
              Update Notes
            </button>

          </div>

        </form>

      </div>

    </aside>

  </section>
</div>

<!--Edit Document-->
<div class="modal fade policy-upload modern-editor-modal" [class.show]="!viewControl.showHideEditFileUpload"
  [style.display]="!viewControl.showHideEditFileUpload ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content editor-modal">

      <!-- ================= HEADER ================= -->
      <div class="editor-header">

        <div class="editor-header-info">
          <div class="editor-file-icon">
            <i class="pi pi-file-edit"></i>
          </div>

          <div>
            <h5 class="editor-title">
              {{ editedData?.message || 'Edit Document' }}
            </h5>

            <p class="editor-subtitle">
              Update document details, assessment and additional content
            </p>
          </div>
        </div>

        <button type="button" class="editor-close" aria-label="Close"
          (click)="hideEditModal(upLoadedFileList, editedData['duration'])">
          <i class="pi pi-times"></i>
        </button>

      </div>


      <!-- ================= STEPPER ================= -->
      <div class="editor-stepper">

        <div class="stepper-track">

          <!-- STEP 1 -->
          <button type="button" class="step-item" [ngClass]="{
              'active': seletedTab === 'lesson',
              'completed': stepperIndex > 0
            }" (click)="openTab($event, 'lesson')">
            <span class="step-icon">
              <span class="step-number">1</span>
              <i class="pi pi-check step-check"></i>
            </span>

            <span class="step-info">
              <span class="step-title">Document</span>
              <!-- <span class="step-description">Basic details</span> -->
            </span>
          </button>

          <span class="step-line"></span>


          <!-- STEP 2 -->
          <button type="button" class="step-item" [ngClass]="{
              'active': seletedTab === 'assessment',
              'completed': stepperIndex > 1
            }" (click)="openTab($event, 'assessment')">
            <span class="step-icon">
              <span class="step-number">2</span>
              <i class="pi pi-check step-check"></i>
            </span>

            <span class="step-info">
              <span class="step-title">Assessment</span>
              <!-- <span class="step-description">Questions</span> -->
            </span>
          </button>

          <span class="step-line"></span>


          <!-- STEP 3 -->
          <button type="button" class="step-item" [ngClass]="{
              'active': seletedTab === 'survey',
              'completed': stepperIndex > 2
            }" (click)="openTab($event, 'survey')">
            <span class="step-icon">
              <span class="step-number">3</span>
              <i class="pi pi-check step-check"></i>
            </span>

            <span class="step-info">
              <span class="step-title">Survey</span>
              <!-- <span class="step-description">Feedback</span> -->
            </span>
          </button>

          <span class="step-line"></span>


          <!-- STEP 4 -->
          <button type="button" class="step-item" [ngClass]="{
              'active': seletedTab === 'poll',
              'completed': stepperIndex > 3
            }" (click)="openTab($event, 'poll')">
            <span class="step-icon">
              <span class="step-number">4</span>
              <i class="pi pi-check step-check"></i>
            </span>

            <span class="step-info">
              <span class="step-title">Poll</span>
              <!-- <span class="step-description">Quick poll</span> -->
            </span>
          </button>

          <span class="step-line"></span>


          <!-- STEP 5 -->
          <button type="button" class="step-item" [ngClass]="{
              'active': seletedTab === 'notes',
              'completed': stepperIndex > 4
            }" (click)="openTab($event, 'notes')">
            <span class="step-icon">
              <span class="step-number">5</span>
              <i class="pi pi-check step-check"></i>
            </span>

            <span class="step-info">
              <span class="step-title">Notes</span>
              <!-- <span class="step-description">Additional notes</span> -->
            </span>
          </button>

        </div>

      </div>


      <!-- ================= CONTENT ================= -->
      <div class="editor-body" appInfiniteScroll infinite-scroll [scrollWindow]="true"
        [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">

        <form [formGroup]="editQuizForm" novalidate>

          <ng-container [ngSwitch]="seletedTab">

            <!-- ================================================= -->
            <!-- DOCUMENT -->
            <!-- ================================================= -->

            <ng-container *ngSwitchCase="'lesson'">

              <section class="editor-section">

                <!-- <div class="section-heading">
                  <div class="section-icon">
                    <i class="pi pi-file"></i>
                  </div>

                  <div>
                    <h3>Document Details</h3>
                    <p>Manage your uploaded file and document information.</p>
                  </div>
                </div> -->


                <div class="row g-4">

                  <!-- FILE -->
                  <div class="col-lg-5">

                    <div class="form-card">

                      <div class="form-card-title">
                        <i class="pi pi-cloud-upload"></i>
                        <span>
                          {{ uploadAttachFile ? 'Attached File' : 'Upload File' }}
                        </span>
                      </div>


                      <!-- UPLOAD -->
                      <div class="upload-zone" *ngIf="!preUploadedFile && !uploadAttachFile">

                        <input type="file" #topicFileInput class="upload-input" name="msg-file"
                          (change)="onFileChange($event)"
                          accept=".png,.jpeg,.jpg,.mp3,.mp4,.wav,.pdf,.ppt,.pptx,.pptm,.xml,.xls,.xlsx,.doc,.docx,.txt" />

                        <div class="upload-icon">
                          <i class="pi pi-cloud-upload"></i>
                        </div>

                        <h4>Upload your file</h4>

                        <p>
                          Click to browse or select a file
                        </p>

                        <span class="upload-limit">
                          Maximum file size: 1GB
                        </span>

                      </div>


                      <!-- UPLOADED FILE -->
                      <div class="uploaded-file" *ngFor="let eachFile of upLoadedFileList">

                        <div class="uploaded-file-icon">
                          <img src="../../../../assets/images/file_types/{{
                              eachFile.mimeType
                            }}.png" width="38" height="38" />
                        </div>

                        <div class="uploaded-file-info">

                          <strong>
                            {{
                            eachFile.name.length > 50
                            ? (eachFile.name | slice:0:50) + '...'
                            : eachFile.name
                            }}
                          </strong>

                          <span>
                            {{ eachFile.size | fileSize }}
                          </span>

                          <progress *ngIf="eachFile.progressVal" class="upload-progress" [value]="eachFile.progressVal"
                            max="100"></progress>

                        </div>

                      </div>


                      <!-- EXISTING FILE -->
                      <div class="existing-file" *ngIf="
                          uploadAttachFile &&
                          upLoadedFileList.length === 0 &&
                          editedData['file_ext']
                        ">

                        <img src="../../../../assets/images/file_types/{{
                            editedData['file_ext']
                          }}.png" width="40" height="40" />

                        <div>
                          <strong>{{ editedData['file_id'] }}</strong>
                          <span>Existing file</span>
                        </div>

                        <button type="button" class="icon-button danger" title="Remove existing file" (click)="
                            removeExitingFile(
                              editedData,
                              editedData['duration']
                            )
                          ">
                          <i class="pi pi-trash"></i>
                        </button>

                      </div>

                    </div>


                    <!-- DURATION -->
                    <div class="form-field">

                      <label>
                        Duration
                      </label>

                      <div class="input-icon">
                        <i class="pi pi-clock"></i>

                        <input type="text" formControlName="duration" placeholder="Video/Audio File Duration"
                          readonly />
                      </div>

                    </div>


                    <!-- DOWNLOAD -->
                    <div class="setting-card">

                      <div class="setting-icon">
                        <i class="pi pi-download"></i>
                      </div>

                      <div class="setting-content">
                        <strong>Allow download</strong>
                        <span>Allow users to download this document</span>
                      </div>

                      <label class="modern-switch">
                        <input type="checkbox" formControlName="is_download" [(ngModel)]="isDownload" />
                        <span></span>
                      </label>

                    </div>

                  </div>


                  <!-- DETAILS -->
                  <div class="col-lg-7">

                    <div class="form-card">

                      <div class="form-card-title">
                        <i class="pi pi-pencil"></i>
                        <span>Document Information</span>
                      </div>


                      <div class="form-field">

                        <label>
                          Title
                          <span class="required">*</span>
                        </label>

                        <input type="text" class="modern-input" name="title" formControlName="message"
                          [(ngModel)]="editedData['message']" placeholder="Enter document title" />

                      </div>


                      <div class="form-field">

                        <label>Description</label>

                        <div class="editor-wrapper">
                          <p-editor formControlName="description" [style]="{ height: '240px' }"></p-editor>
                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </section>

            </ng-container>


            <!-- ================================================= -->
            <!-- ASSESSMENT -->
            <!-- ================================================= -->

            <ng-container *ngSwitchCase="'assessment'">

              <section class="editor-section">

                <div class="section-heading">

                  <div class="section-icon">
                    <i class="pi pi-list-check"></i>
                  </div>

                  <div>
                    <h3>Assessment</h3>
                    <p>Create questions and configure assessment settings.</p>
                  </div>

                </div>


                <!-- ASSESSMENT SETTINGS -->

                <div class="settings-grid">

                  <div class="setting-card">

                    <div class="setting-icon">
                      <i class="pi pi-percentage"></i>
                    </div>

                    <div class="setting-content">
                      <strong>Minimum Score</strong>
                      <span>Required percentage to pass</span>

                      <input type="text" class="modern-input compact" formControlName="min_percentage"
                        placeholder="0%" />
                    </div>

                  </div>


                  <div class="setting-card">

                    <div class="setting-icon">
                      <i class="pi pi-refresh"></i>
                    </div>

                    <div class="setting-content">
                      <strong>Allow Re-Test</strong>
                      <span>Allow learners to retake assessment</span>
                    </div>

                    <label class="modern-switch">
                      <input type="checkbox" formControlName="is_allow_retest" [(ngModel)]="isAllowRetest" />
                      <span></span>
                    </label>

                  </div>


                  <div class="setting-card">

                    <div class="setting-icon">
                      <i class="pi pi-sort-numeric-up"></i>
                    </div>

                    <div class="setting-content">

                      <strong>Random Questions</strong>
                      <span>Number of questions shown</span>

                      <input type="text" class="modern-input compact" formControlName="random_question"
                        placeholder="Number" (keydown)="keyDownHandler($event)"
                        (keypress)="numericOnlyHandler($event)" />

                    </div>

                  </div>

                </div>


                <!-- QUESTION ACTIONS -->

                <div class="creation-panel">

                  <div>
                    <h4>Build your assessment</h4>
                    <p>
                      Create questions manually or let AI generate them.
                    </p>
                  </div>

                  <div class="creation-actions">

                    <button type="button" class="btn-modern primary" *ngIf="
                        trainLLM &&
                        editQuizForm.controls['assessment'].length === 0
                      " (click)="GenerateQuestion()">
                      <i class="pi pi-sparkles"></i>
                      AI Generated Questions
                    </button>

                    <button type="button" class="btn-modern secondary" *ngIf="
                        editQuizForm.controls['assessment'].length === 0
                      " (click)="onCreateAssQuestion()">
                      <i class="pi pi-plus"></i>
                      Add Question
                    </button>

                  </div>

                </div>


                <!-- QUESTIONS -->

                <ng-container formArrayName="assessment">

                  <div class="question-card" *ngFor="
                      let assessmentCtrl of assQuestion().controls;
                      let questIndex = index
                    " [formGroupName]="questIndex">

                    <div class="question-card-header">

                      <div class="question-number">
                        {{ questIndex + 1 }}
                      </div>

                      <div class="question-header-info">
                        <span>Question {{ questIndex + 1 }}</span>
                        <small>Configure question and answers</small>
                      </div>

                      <button type="button" class="icon-button danger" (click)="removeAssQuestion(questIndex)">
                        <i class="pi pi-trash"></i>
                      </button>

                    </div>


                    <div class="question-card-body">

                      <div class="row g-3">

                        <div class="col-md-8">

                          <label class="form-label">
                            Question
                          </label>

                          <input type="text" class="modern-input" formControlName="question"
                            placeholder="Enter your question" />

                        </div>


                        <div class="col-md-2">

                          <label class="form-label">
                            Mark
                          </label>

                          <input type="text" class="modern-input" formControlName="mark" placeholder="Mark"
                            (keypress)="numericOnlyHandler($event)" />

                        </div>


                        <div class="col-md-2">

                          <label class="form-label">
                            Type
                          </label>

                          <div class="question-type">

                            <label *ngFor="
                                let item of questions;
                                let i = index
                              ">
                              <input type="radio" [value]="item.value" formControlName="answer_type" (click)="
                                  onSelectedType(item, questIndex)
                                " />

                              <span>
                                {{ item.viewValue }}
                              </span>

                            </label>

                          </div>

                        </div>

                      </div>


                      <!-- ANSWERS -->

                      <div class="answers-section">

                        <div class="answers-header">

                          <div>
                            <strong>Answers</strong>
                            <span>Select the correct answer</span>
                          </div>

                          <button type="button" class="btn-modern small secondary" *ngIf="isShown[questIndex]"
                            (click)="onCreateAssOption(questIndex)">
                            <i class="pi pi-plus"></i>
                            Add Choice
                          </button>

                        </div>


                        <div formArrayName="answer" class="answers-list">

                          <div class="answer-row" *ngFor="
                              let answerCtrl of assQuestAnswers(
                                questIndex
                              ).controls;
                              let optionIndex = index
                            " [formGroupName]="optionIndex">

                            <span class="answer-letter">
                              {{ String.fromCharCode(65 + optionIndex) }}
                            </span>

                            <input type="text" class="modern-input" formControlName="answer"
                              placeholder="Enter answer" />

                            <label class="correct-answer">

                              <input type="radio" [name]="'correctAnswer' + questIndex" [checked]="
                                  answerCtrl.value.is_correct_answer
                                " (click)="
                                  onCheckedAnswer(
                                    $event,
                                    assessmentCtrl,
                                    questIndex,
                                    optionIndex
                                  )
                                " />

                              <span>
                                Correct
                              </span>

                            </label>

                            <button type="button" class="icon-button danger" *ngIf="
                                assQuestAnswers(questIndex)
                                  .controls.length > 1
                              " (click)="
                                removeAssOptions(
                                  questIndex,
                                  optionIndex,
                                  answerCtrl
                                )
                              ">
                              <i class="pi pi-trash"></i>
                            </button>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </ng-container>

              </section>

            </ng-container>


            <!-- ================================================= -->
            <!-- SURVEY / POLL / NOTES -->
            <!-- ================================================= -->

            <ng-container *ngSwitchCase="'survey'">

              <section class="editor-section">

                <div class="section-heading">
                  <div class="section-icon">
                    <i class="pi pi-comments"></i>
                  </div>

                  <div>
                    <h3>Survey</h3>
                    <p>Create survey questions and answer choices.</p>
                  </div>
                </div>

                <!-- Keep your existing survey formArray here -->

              </section>

            </ng-container>


            <ng-container *ngSwitchCase="'poll'">

              <section class="editor-section">

                <div class="section-heading">
                  <div class="section-icon">
                    <i class="pi pi-chart-bar"></i>
                  </div>

                  <div>
                    <h3>Poll</h3>
                    <p>Create a quick poll for your learners.</p>
                  </div>
                </div>

                <!-- Keep your existing poll formArray here -->

              </section>

            </ng-container>


            <ng-container *ngSwitchCase="'notes'">

              <section class="editor-section">

                <div class="section-heading">
                  <div class="section-icon">
                    <i class="pi pi-file-edit"></i>
                  </div>

                  <div>
                    <h3>Notes</h3>
                    <p>Add additional notes or learning material.</p>
                  </div>
                </div>

                <!-- Keep your existing notes formArray here -->

              </section>

            </ng-container>

          </ng-container>

        </form>

      </div>


      <!-- ================= FOOTER ================= -->

      <div class="editor-footer">

        <button type="button" class="btn-modern ghost" [disabled]="upLoadedFileList.length > 0" (click)="
            hideEditModal(
              upLoadedFileList,
              editedData['duration']
            )
          ">
          Cancel
        </button>


        <div class="footer-actions">

          <!-- FIRST STEP -->

          <button *ngIf="stepperIndex === 0" type="button" class="btn-modern primary" [disabled]="
              editQuizForm.controls['message'].invalid ||
              (!preUploadedFile && !uploadAttachFile)
            " (click)="Continue()">
            Continue
            <i class="pi pi-arrow-right"></i>
          </button>


          <!-- BACK -->

          <button *ngIf="stepperIndex >= 2" type="button" class="btn-modern secondary" (click)="Stepback()">
            <i class="pi pi-arrow-left"></i>
            Back
          </button>


          <!-- SAVE -->

          <button *ngIf="stepperIndex >= 1" type="button" class="btn-modern secondary" (click)="SaveLesson()">
            <i class="pi pi-save"></i>
            Save
          </button>


          <!-- NEXT -->

          <button *ngIf="stepperIndex >= 1 && stepperIndex < 4" type="button" class="btn-modern primary"
            (click)="trainLLM ? Continue() : newLessonCreate()">
            Next
            <i class="pi pi-arrow-right"></i>
          </button>


          <!-- COMPLETE -->

          <button *ngIf="stepperIndex === 4" type="button" class="btn-modern success"
            (click)="trainLLM ? Continue() : newLessonCreate()">
            <i class="pi pi-check"></i>
            Complete
          </button>

        </div>

      </div>

    </div>
  </div>
</div>
<!--End edit document-->

<div class="empty-state-wrapper" *ngIf="classFileList.length === 0">
  <div class="empty-state-card">

    <div class="empty-state-icon">
      <i class="pi pi-folder-open"></i>
    </div>

    <div class="empty-state-content">
      <h4>No records found</h4>
      <p>
        There are no records available at the moment.
        Start adding content to see it listed here.
      </p>
    </div>

  </div>
</div>

<div class="showAssignment">
  <!--Assessment Test View-->
  <div class="modal" [ngClass]="{ 'is-active': showHiddenAssessmentModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole != 1 && isUserRole != 2 && viewControl.showAssessmentMarks">
        <form [formGroup]="assessmentForm" class="assQuestTest">
          <div class="card-header">
            <p class="card-header-title">Assessment Test</p>
            <span class="card-header-title is-size-6 has-text-right"
              style="font-weight: normal; position: absolute; right: 0">No.of Questions: {{ pager.count }}</span>
            <button class="delete" aria-label="close" *ngIf="isUserRole === 1 || isUserRole === 2"
              (click)="hideModalAssessment(mesgIds)"></button>
          </div>
          <div class="card-content scroll-bar pos-relative" appInfiniteScroll infinite-scroll
            [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
            [scrollWindow]="false">
            <div class="content">
              <div class="notification is-danger is-light" *ngIf="assetFormValid">
                <button class="delete"></button>
                Must check some option!
              </div>
              <div class="question">
                <div *ngFor="let data of getAssessmentData; let i = index" style="padding-bottom: 10px">
                  <div *ngIf="data.question_type === 'question'">
                    <h3 class="is-medium label is-size-6">
                      Q{{ i + 1 }}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <div *ngIf="data.answer_type === 'choice'; else elseTemplate">
                      <div class="options surveyquiz">
                        <div class="" *ngFor="let option of data.answer; let i = index">
                          <div class="option">
                            <div class="field">
                              <input class="is-checkradio" id="{{ data.question_id }}-{{
                                  option.answer_id
                                }}" type="radio" name="{{ data.question_id }}-answers" value="{{ option.answer_id }}"
                                (change)="
                                  onSelectedAssRadio(
                                    data,
                                    option,
                                    assessmentForm.value
                                  )
                                " />
                              <label class="is-size-6" style="font-size: 15px !important" for="{{ data.question_id }}-{{
                                  option.answer_id
                                }}">{{ option.answer }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <textarea name="user_answer" class="textarea" id="" cols="30" rows="5"
                        placeholder="Enter the short answer here..." formControlName="user_answer" (change)="
                          onSelectedAssRadio(data, option, assessmentForm.value)
                        "></textarea>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="has-text-right footer-elibrary">
              <button type="button" class="button mar-0-5 is-small" (click)="hideAssessmentModal(mesgIds)">
                Cancel
              </button>
              <button type="button" class="button is-link is-small" *ngIf="!showBtnSpinner"
                [disabled]="!assessmentSubmit" (click)="
                  submitAssessmentQuiz(
                    assessmentForm.value,
                    mesgIds,
                    'question'
                  )
                ">
                Submit Test
              </button>
              <a class="button is-link is-loading is-small" style="min-width: 100px" *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Result</p>
          <button class="button is-primary is-light" style="margin-right: 14px" (click)="onClickTakeRetest(mesgIds)"
            *ngIf="isTakeRetest">
            Take Retest
          </button>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Test Complete Date</th>
                  <th scope="col">Percentage %</th>
                  <!-- <th scope="col"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let st of getUserTestResult">
                  <td>{{ st.createdAt | date: "MM/dd/yyyy" }}</td>
                  <td>{{ st.percentage }}</td>
                  <!-- <td>
                    <button type="button" class="button mar-0-5 is-small is-link">Teacher Remarks</button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="isUserRole === 1 || isUserRole === 2">
        <div class="card-header">
          <p class="card-header-title d-flex align-items-center">

            <a *ngIf="
                !viewControl.individualStudentResult &&
                viewControl.showIndStudentResult
              " (click)="hideStudentResults()" class="mar-0-5 has-tooltip-right" data-tooltip="Back to user"
              style=" padding-top:10px;">
              <i class="fa fa-arrow-left" aria-hidden="true" style="color: #fff !important;"></i>
            </a>
            <a *ngIf="!viewControl.showIndStudentResult" (click)="removeIndStudentResult()"
              class="mar-0-5 has-tooltip-right" data-tooltip="Back to user" style=" padding-top:10px;">
              <i class="fa fa-arrow-left" aria-hidden="true" style="color: #fff !important;"></i>
            </a>
            <span> Assessment Result</span>
          </p>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </div>
        <div class="card-content" *ngIf="
            viewControl.individualStudentResult &&
            viewControl.showIndStudentResult
          ">
          <!-- <div class="columns"> -->
          <div *ngIf="studentResult.length > 0; else elseTemplate">
            <!-- <div class="column is-12 is-fullwidth"> -->
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User Name</th>
                  <th>Email Id</th>
                  <!-- <th>Percentage %</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of studentResult">
                  <td>{{ m.createdAt | date: "MM/dd/yyyy" }}</td>
                  <td style="text-transform: capitalize" [innerHTML]="m.student_name"></td>
                  <td>{{ m.email_id }}</td>
                  <!-- <td>{{ m.percentage }}</td> -->
                  <td>
                    <button type="button" class="button mar-0-5 is-small is-link" (click)="indStudentResult(m)">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- </div> -->
          </div>
          <!-- </div> -->
          <ng-template #elseTemplate>
            <span class="">There is no test submitted by the user</span>
          </ng-template>
        </div>
        <div class="card-content scroll-bar pos-relative" *ngIf="
            !viewControl.individualStudentResult &&
            viewControl.showIndStudentResult
          ">
          <div class="content">
            <div class="question">
              <h3 style="text-transform: capitalize">
                {{ individualStudentRecord[0]["student_name"] }}
              </h3>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Date & Time</th>
                    <th>Percentage %</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let m of individualStudentRecord">
                    <td>{{ m.createdAt | date: "MM/dd/yyyy hh:mm" }}</td>
                    <td>{{ m.percentage }}</td>

                    <td>
                      <button type="button" class="button mar-0-5 is-small is-link" [ngClass]="{
                          btnQAdisabled: m.answer_submissionId == null
                        }" (click)="onClickStudentIndResult(m)">
                        View QA
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card-content scroll-bar pos-relative" *ngIf="!viewControl.showIndStudentResult">
          <div class="content">
            <div class="question">
              <form [formGroup]="studentRemarkForm" novalidate>
                <div *ngFor="let data of viewStudentQA; let i = index" style="padding-bottom: 10px">
                  <div *ngIf="data.question_type == 'question'">
                    <h3 class="is-medium label is-size-6">
                      Q {{ i + 1 }}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <!-- <span *ngIf="data.answer_type==='text'" class="has-text-grey-lighter has-text-weight-bold" style="float: right;">Test Mark : {{data.test_mark}}</span> -->
                    <div *ngIf="data.answer_type === 'choice'; else elseTemplate">
                      <span *ngIf="
                          data.is_correct_answer === true;
                          else elseTemplate
                        ">
                        <span class="has-text-success">{{ data.answer }}</span>
                      </span>
                      <ng-template #elseTemplate>
                        <span class="has-text-danger">{{ data.answer }}</span>
                      </ng-template>
                    </div>
                    <ng-template #elseTemplate>
                      <h4 class="subtitle" style="
                          font-size: 14px;
                          margin-bottom: 5px;
                          color: #008000;
                        ">
                        Answer:
                      </h4>
                      <span>
                        {{ data.user_answer }}
                      </span>
                      <h5 class="is-size-6 has-text-danger-dark has-text-weight-bold" style="color: red;">Comments:</h5>
                      <div class="teacherRemarks" *ngIf="data.teacher_remark===''">
                        <input type="hidden" class="input" id="question_{{data.question_id}}" name="question_id"
                          style="margin-top: 10px" formControlName="question_id" value="{{ data.question_id }}" />
                        <textarea class="textarea" id="remark_{{data.question_id}}" name="remarks"
                          formControlName="remarks" (change)="
                            changeEvtTeacherRemark(data, studentRemarkForm.value)" cols="10" rows="2"
                          placeholder="Remarks"></textarea>
                        <input type="text" id="mark_{{data.question_id}}" style="margin-top: 10px" class="input"
                          formControlName="mark" (keypress)="numericOnlyHandler($event)"
                          (change)="changeRemarksMark(data, studentRemarkForm.value)" />
                      </div>
                      <div class="teacherRemarks" *ngIf="data.teacher_remark!=''">
                        <span class="has-text-info">{{data.teacher_remark}}</span><br />
                        <span class="has-text-success">Mark: {{data.teacher_mark}}</span>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <footer class="card-footer">
                  <div class="column is-12 has-text-right">
                    <button type="button" class="button mar-0-5 is-small" (click)="removeIndStudentResult()">
                      Back
                    </button>
                    <button type="button" class="button is-link is-small" [disabled]="
                    (studentRemarkForm.valid && !studentRemarkForm.dirty) ||
                    studentRemarkForm.invalid
                  " (click)="submitRemarks(data, studentRemarkForm.value)" *ngIf="!showBtnSpinner"> Submit</button>
                    <a class="button is-link is-loading is-small" style="min-width: 100px;" *ngIf="showBtnSpinner"></a>
                  </div>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---Survey Records-->
  <div class="modal survey-modal" [ngClass]="{ 'is-active': showHideSurveyModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole != 1 && isUserRole != 2 && viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <!-- <button type="button" class="button is-outlined is-small" style="margin-top: 7px"
            (click)="hideSurveyQuizModal(mesgIds)">
            Cancel
          </button> -->
          <button class="delete" aria-label="close" (click)="hideSurveyQuizModal(mesgIds)"></button>
        </div>
        <div class="card-content scroll-bar pos-relative" infinite-scroll>
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div class="survey-question" *ngFor="let data of filteredQuestions; let i = index">
                <!-- <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div> -->
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let option of data.answer; let i = index">
                    <div class="option">
                      <div class="field">
                        <input class="is-checkradio" id="{{ option.answer_id }}-{{ data.question_id }}" type="radio"
                          name="{{ data.question_id }}-answers" [(ngModel)]="option.selected"
                          value="{{ option.answer_id }}" (change)="onSelectedSurRadio(data, option)" #surveyCheck />
                        <label [attr.for]="option.answer_id + '-' + data.question_id">{{ option.answer }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous"
              [ngClass]="{ hidePreviousBtn: pager.index === 0 }" [disabled]="pager.index == 0"
              [hidden]="pager.index > 1" (click)="getPreviewNext(pager.index - 1)">
              Previous
            </button>
            <div *ngIf="pager.index + 1 >= pager.count; else elseTemplate">
              <button type="button" class="button is-link is-small pagination-next answerSubmit"
                [disabled]="!surveySubmit" *ngIf="!showBtnSpinner" (click)="
                  submitAssessmentQuiz(filteredQuestions, mesgIds, 'survey')
                ">
                Submit Answer
              </button>
              <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px"
                *ngIf="showBtnSpinner"></a>
            </div>
            <ng-template #elseTemplate>
              <button type="button" class="button is-outlined pagination-next"
                (click)="getPreviewNext(pager.index + 1)">
                Next
              </button>
            </ng-template>
          </nav>
        </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small">Already survey is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole === 1 || isUserRole === 2">
        <div class="card-header">
          <p class="card-header-title">Survey Result</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div *ngFor="let data of filterReportSurvey; let i = index">
                <!-- <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div> -->
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let opt of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right">{{ opt.count }} Votes</span>
                        <progress class="progress is-info" [ngClass]="{
                            'is-success': totalUserCount > opt.count
                          }" value="{{ opt.count }}" max="{{ totalUserCount }}">
                          {{ opt.count }}
                        </progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index == 0"
              (click)="getPreviewNext(pager.index - 1)">
              Previous
            </button>
            <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1 >= pager.count"
              (click)="getPreviewNext(pager.index + 1)">
              Next
            </button>
          </nav>
        </footer>
      </div>
    </div>
  </div>

  <!--Poll Records -->
  <div class="modal poll-modal" [ngClass]="{ 'is-active': showHidePollModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card" *ngIf="isUserRole != 1 && isUserRole != 2 && viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollActiveModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="getmode == 'pollsQuiz'">
              <div class="poll-question" *ngFor="let data of pollfilterQuestions; let i = index">
                <!-- <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div> -->
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let option of data.answer; let i = index">
                    <div class="option">
                      <div class="field">
                        <input class="is-checkradio" id="{{ option.answer_id }}-{{ data.question_id }}" type="radio"
                          name="{{ data.question_id }}-answers" [(ngModel)]="option.selected"
                          value="{{ option.answer_id }}" (change)="onSelectedSurRadio(data, option)" #surveyCheck />
                        <label [attr.for]="option.answer_id + '-' + data.question_id">{{ option.answer }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous"
              [ngClass]="{ hidePreviousBtn: pager.index === 0 }" [disabled]="pager.index == 0"
              (click)="getPollNextPrev(pager.index - 1)">
              Previous
            </button>
            <div *ngIf="pager.index + 1 >= pager.count; else elseTemplate">
              <button type="button" class="button is-link is-small pagination-next answerSubmit"
                [disabled]="!pollBtnSubmit" *ngIf="!showBtnSpinner" (click)="
                  submitAssessmentQuiz(pollfilterQuestions, mesgIds, 'polls')
                ">
                Submit Answer
              </button>
              <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px"
                *ngIf="showBtnSpinner"></a>
            </div>
            <ng-template #elseTemplate>
              <button type="button" class="button is-outlined pagination-next"
                (click)="getPollNextPrev(pager.index + 1)">
                Next
              </button>
            </ng-template>
          </nav>
        </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small">Already poll is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole === 1 || isUserRole === 2">
        <div class="card-header">
          <p class="card-header-title">Poll Result</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div *ngFor="let data of pollsfilterReports; let i = index">
                <!-- <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div> -->
                <h3 class="is-medium is-size-6">
                  {{ pager.index + 1 }}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let opt of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right">{{ opt.count }} Votes</span>
                        <progress class="progress is-info" [ngClass]="{
                            'is-success': totalUserCount > opt.count
                          }" value="{{ opt.count }}" max="{{ totalUserCount }}">
                          {{ opt.count }}
                        </progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index === 0"
              (click)="getPollNextPrev(pager.index - 1)">
              Previous
            </button>
            <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1 >= pager.count"
              (click)="getPollNextPrev(pager.index + 1)">
              Next
            </button>
          </nav>
        </footer>
      </div>
    </div>
  </div>


  <!--Summary-->
  <div class="modal fade summarization-popup" [ngClass]="{ 'show d-block': showSummarizationPopup }" tabindex="-1"
    role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">

      <div class="modal-content">

        <!-- Header -->
        <div class="modal-header">

          <div class="summary-title-wrapper">
            <div class="summary-icon">
              <i class="fa-solid fa-wand-magic-sparkles"></i>
            </div>

            <div>
              <h5 class="modal-title">
                Summarization
              </h5>

              <!-- <span class="summary-subtitle">
                AI-generated document summary
              </span> -->
            </div>
          </div>

          <button type="button" class="summary-close" (click)="closeSummarization()" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>

        </div>


        <!-- Body -->
        <div class="modal-body">

          <!-- Metadata -->
          <div class="summary-section" *ngIf="MetaData?.length">

            <div class="section-title">

              <div class="section-icon metadata-icon">
                <i class="fa-solid fa-circle-info"></i>
              </div>

              <div>
                <h6>Metadata</h6>
                <!-- <span>Document information</span> -->
              </div>

            </div>

            <div class="metadata-grid">

              <div class="metadata-item" *ngFor="let item of MetaData">

                <span class="metadata-label">
                  {{ item.key }}
                </span>

                <strong class="metadata-value">
                  {{ item.value || '—' }}
                </strong>

              </div>

            </div>

          </div>


          <!-- Category -->
          <div class="summary-section" *ngIf="SummaryCategory?.length">

            <div class="section-title">

              <div class="section-icon category-icon">
                <i class="fa-solid fa-tags"></i>
              </div>

              <div>
                <h6>Summary Category</h6>
                <!-- <span>Topics identified in the document</span> -->
              </div>

            </div>

            <div class="category-list">

              <span class="category-chip" *ngFor="let category of SummaryCategory">
                <i class="fa-solid fa-tag"></i>
                {{ category }}
              </span>

            </div>

          </div>


          <!-- Summary -->
          <div class="summary-section">

            <div class="section-title">

              <div class="section-icon summary-icon">
                <i class="fa-solid fa-align-left"></i>
              </div>

              <div>
                <h6>Summary</h6>
                <!-- <span>AI-generated overview</span> -->
              </div>

            </div>

            <div class="summary-text-wrapper">

              <div class="summary-accent"></div>

              <div class="summary-text" [innerHTML]="changeNewLine(SummarizationText)"></div>

            </div>

          </div>

        </div>


        <!-- Footer -->
        <div class="modal-footer">

          <!-- <span class="ai-generated">
            <i class="fa-solid fa-robot"></i>
            Generated by AI
          </span> -->

          <button type="button" class="btn summary-btn" (click)="closeSummarization()">
            Close
          </button>

        </div>

      </div>
    </div>
  </div>


  <!-- Backdrop -->
  <div class="modal-backdrop fade" [ngClass]="{ 'show': showSummarizationPopup }" *ngIf="showSummarizationPopup"
    (click)="closeSummarization()"></div>
</div>

<pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
<progress-spinner *ngIf="questionGenerateLoader"></progress-spinner>

     <app-excel-editor
  [documentId]="excelEditorDocumentId"
  [documentFileName]="excelEditorFileName"
  [documentFileType]="excelEditorFileExt"
  [companyId]="companyId"
  [classId]="group_id"
  [modelType]="modelType"
  [stateCode]="excelEditorStateCode"
  [llm_train_id] = excelEditorLLMTrainId
  [documentTitle]="excelEditorDocumentTitle"
  [(visible)]="showExcelEditor"
  (onSave)="onExcelEditorSave($event)"
  (onCancel)="onExcelEditorCancel()"
></app-excel-editor>
